import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  sub?: string;
  id?: string;
  className?: string;
};
export function CtaButton({
  label,
  sub,
  id,
  className = ''
}: CtaButtonProps) {
  return <div className={`w-full ${className}`} data-id="element-78" data-mp="cksp8iqpncgu">
      <a id={id} href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-2 rounded-2xl bg-lime px-5 py-4 text-center text-base font-extrabold uppercase leading-tight tracking-wide text-black shadow-[0_10px_30px_-10px_rgba(198,230,43,0.7)] transition hover:bg-lime-400 focus:outline-none focus-visible:ring-4 focus-visible:ring-lime/40 active:scale-[0.98] sm:text-lg" data-id="element-79" data-mp="cjzpi1q65n87">
        <span data-id="element-80" data-mp="vddc9jjqancq">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform group-hover:translate-x-1" data-id="element-81" data-mp="19b1ns0rwoi54" />
      </a>
      {sub ? <p className="mt-3 text-center text-[11px] font-medium uppercase tracking-wider text-white/50 sm:text-xs" data-id="element-82" data-mp="15a9e56f4gb8b">
          {sub}
        </p> : null}
    </div>;
}